export default __webpack_public_path__ + "static/media/login-background-main.415e0e4a.svg";